import { CmsFieldDTO as BackendFieldDTOCmsConfig } from '@jnext/ts-axios-coreuser/models/cms-field-dto';
import { ComponentConfigDTO } from '@jnext/ts-axios-coreuser/models/component-config-dto';
import { ComponentConfigOption } from '@jnext/ts-axios-coreuser/models/component-config-option';
import { FieldDTO as BackendFieldDTO } from '@jnext/ts-axios-coreuser/models/field-dto';
// import { FieldTypeEnum } from '@jnext/ts-axios-coreuser/models/field-type-enum';
import { ColProps } from 'antd';
import { CropRenderMode } from '.';
import { JRadioStyle } from '../../JForm/JRadioGroup';
import {TooltipDTO} from "@jnext/ts-axios-coreuser";

export enum FieldDTOTypes {
  'AVATAR' = "AVATAR",
  'CHECKBOX' = "CHECKBOX",
  'COMPOSED' = "COMPOSED",
  'COUNTRY' = "COUNTRY",
  'DATE' = "DATE",
  'DATES_RANGE' = "DATES_RANGE",
  'DATERANGE' = "DATERANGE",
  'DATETIME' = "DATETIME",
  'DATETIMERANGE' = "DATETIMERANGE",
  'EMAIL' = "EMAIL",
  'FILE' = "FILE",
  'INVITATION' = "INVITATION",
  'JADDRESS' = "JADDRESS",
  'JAVATAR' = "JAVATAR",
  'JCHECKBOX' = "JCHECKBOX",
  'JCOMPOSED' = "JCOMPOSED",
  'JCOUNTRY' = "JCOUNTRY",
  'JDATE' = "JDATE",
  'JDATES_RANGE' = "JDATES_RANGE",
  'JDATERANGE' = "JDATERANGE",
  'JDATETIME' = "JDATETIME",
  'JDATETIMERANGE' = "JDATETIMERANGE",
  'JDISCRIMINATING' = "JDISCRIMINATING",
  'JEMAIL' = "JEMAIL",
  'JFILE' = "JFILE",
  'JINVITATION' = "JINVITATION",
  'JMULTISELECT' = "JMULTISELECT",
  'JNUMBER' = "JNUMBER",
  'JPASSWORD' = "JPASSWORD",
  'JPHONE' = "JPHONE",
  'JPRIVACY' = "JPRIVACY",
  'JRADIO' = "JRADIO",
  'JSELECT' = "JSELECT",
  'JTEXT' = "JTEXT",
  'JTEXTAREA' = "JTEXTAREA",
  'MULTISELECT' = "MULTISELECT",
  'NUMBER' = "NUMBER",
  'PASSWORD' = "PASSWORD",
  'PHONE' = "PHONE",
  'PRIVACY' = "PRIVACY",
  'RADIO' = "RADIO",
  'SELECT' = "SELECT",
  'TEXT' = "TEXT",
  'TEXTAREA' = "TEXTAREA",
}

export type JFieldDTOType = `${FieldDTOTypes}`
export type JComponentConfigOption = ComponentConfigOption & {
  dependsValue?: string | undefined
}

export interface JSelectConfig {
  dependsOn?: string;
  disableAllowClear?: boolean;
  searcheable?: boolean
}
export interface JFileConfig {
  /**
   * Enable crop in JFileUpload
   * @default false
   * @type {boolean}
   */
  enableCrop?: boolean;
  /**
   * Defines if JFileUpload render minimal view
   *
   * @type {boolean}
   */
  minimal?: boolean;
  /**
   * Define JFileUpload accept ext
   *
   * @type {string}
   */
  accept?: string;
  /**
   * Defines if JFileUpload allow multiple upload
   * @default false
   * @type {boolean}
   */
  multiple?: boolean;
  /**
   * Defines if JFileUpload hide preview of upload files
   * @default false
   * @type {boolean}
   */
  hidePreview?: boolean;
  /**
   * Defines max file upload
   * @default false
   * @type {number}
   */
  maxCount?: number;
  /**
   * Defines if crop render in modal
   * @default 'replace''
   * @type {CropRenderMode}
   */
  cropRenderMode?: CropRenderMode;
  /**
   * Defines max size limit in bytes
   * @default false
   * @type {number}
   */
  maxSize?: number;
}

export interface JAvatarConfig extends Omit<JFileConfig, 'multiple' | 'maxCount' | 'accept'> {
  /**
   * Defines if JAVATAR render image preview
   *
   * @type {boolean}
   */
  showAvatarPreview?: boolean;
}
export interface JDateTimeConfig {
  /**
   * Defines if JDATETIME/RANGETIME show time
   * @default false
   * @type {boolean}
   */
  showTime?: boolean;
  minDate?: string | 'TODAY';
  maxDate?: string | 'TODAY';
}
export interface JDateConfig extends Omit<JDateTimeConfig, 'showTime'> {
  minDate?: string | 'TODAY';
  maxDate?: string | 'TODAY';
}
export interface JTextConfig {
  /**
   * define JTEXT Suffix icon
   */
  status?: 'VALID' | 'INVALID';
}
export interface JRadioConfig {
  radioStyle?: JRadioStyle;
}
export type ComponentConfigExtended = {
  options: JComponentConfigOption[];
} & JSelectConfig &
  JFileConfig &
  JAvatarConfig &
  JDateTimeConfig &
  JDateConfig &
  JTextConfig &
  JRadioConfig


export interface JCmsFieldDTO extends BackendFieldDTOCmsConfig {
  colConfig?: ColProps,
  placeholder?: string,
  defaultValues?: any[]
  validationMessage?: string,
  additionalText?: string,
  tooltip?: TooltipDTO,
  componentConfig: ComponentConfigDTO & ComponentConfigExtended,
  autocomplete?: string
}
export interface JFieldDTO<HurlIdEnum extends string = string> extends BackendFieldDTO {
  validationFrontendFunction?: string
  hurlId: HurlIdEnum,
  cmsConfig: JCmsFieldDTO,
  type: `${FieldDTOTypes}`,
  repeateble?: boolean,
  children?: JFieldDTO[],
  values?: any[],
  accessKey?: boolean,
  keyRank?: number,
}

export interface FieldDTOItemPayload<HurlIdEnum extends string = string> extends Pick<JFieldDTO, 'type' | 'values' | 'accessKey' | 'keyRank'> {
  hurlId: HurlIdEnum,
  children?: FieldDTOItemPayload<HurlIdEnum>[]
}
export type FieldDTOPayload<HurlIdEnum extends string = string> = FieldDTOItemPayload<HurlIdEnum>[]
